import _get from 'lodash/get';
import { SET_CURRENT_USER, RESET_APP, SET_QR_CODE_IMAGE, RESET_LOGIN_INFO } from '../constants/action_constants';
import { newAlert, serverStatusError } from './alert_actions';
import { history } from '../helpers/history';
import RequestService from '../services/request_service';
import { sendRequest, completeRequest } from './request_state';
import { fetchOrgData } from './global_setting_actions';
const requestService = new RequestService('node');

export function setCurrentUser(data) {
  return {
    type: SET_CURRENT_USER,
    data: data,
    permissions: data.permissions.map((p) => p.action),
  };
}

export function setQrCodeImage(data) {
  return {
    type: SET_QR_CODE_IMAGE,
    data,
  };
}

export const resetLoginInfo = () => async (dispatch) => {
  dispatch({ type: RESET_LOGIN_INFO });
}

export const login = (email, password, otp = null) => async (dispatch) => {
  dispatch(sendRequest('Login'));
  try {
    const payload = await requestService.post('sessions',
      {
        login: email,
        password: password,
        otp
      },
    );

    if (payload.data.needVerification) {
      dispatch(setQrCodeImage(payload.data));
    } else {
      const currentUser = payload.data.attributes;
      dispatch(setCurrentUser(currentUser));
      dispatch(newAlert('success', 's', 'Bienvenido al Sistema Brilla'));
      dispatch(fetchOrgData());
      history.push('/');
    }
    return true;
  } catch (errors) {
    dispatch(serverStatusError(errors));
    if (errors) {
      const e = await errors.json();
      e &&
        dispatch(
          newAlert('error', 'ERROR:', e.errors.base)
        );
    }
    return false;
  } finally {
    dispatch(completeRequest('Login'));
  }
};

export function logout() {
  requestService.get('sessions/logout');
  history.push('/login');
  return {
    type: RESET_APP,
    data: null,
  };
};
